import { render, staticRenderFns } from "./person_detail.vue?vue&type=template&id=542c9627&scoped=true"
import script from "./person_detail.vue?vue&type=script&lang=js"
export * from "./person_detail.vue?vue&type=script&lang=js"
import style0 from "./person_detail.vue?vue&type=style&index=0&id=542c9627&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "542c9627",
  null
  
)

export default component.exports